import DashboardHome from "./DashboardHome";

import useDashboard from "../hooks/useDashboard";
import useRemoteAssets from "../utils/useRemoteAssets";

export default function Dashboard() {
    const ASSETS = useRemoteAssets();
  const {
  toggleMenu,
  handleCreateOrg,
  profilePicURL,
  moduleIcons,
  Button,
  loading,
} = useDashboard();

  const authToken = sessionStorage.getItem("AUTH_TOKEN");

  if (!ASSETS || loading) {
  return <div>Loading...</div>;
}

  const fixSvg = (
    svg: string,
    index: number
  ) => {

    if (!svg) return "";

    let updated = svg;

    updated = updated

      .replace(
        /id="(.*?)"/g,
        (_, id) =>
          `id="${id}-${index}"`
      )

      .replace(
        /url\(#(.*?)\)/g,
        (_, id) =>
          `url(#${id}-${index})`
      )

      .replace(
        /href="#(.*?)"/g,
        (_, id) =>
          `href="#${id}-${index})`
      );

    updated = updated.replace(
      /<defs>[\s\S]*?<\/defs>/g,
      ""
    );

    updated = updated.replace(
      /fill="(.*?)"/g,
      (_, color) => {

        if (color === "none") {
          return `fill="none"`;
        }

        if (
          color.toLowerCase() ===
            "#ffffff" ||

          color.toLowerCase() ===
            "#fff" ||

          color.toLowerCase() ===
            "white"
        ) {

          return `fill="white"`;
        }

        return `fill="black"`;
      }
    );

    updated = updated.replace(
      /stroke="(.*?)"/g,
      (_, color) => {

        if (
          color.toLowerCase() ===
            "#ffffff" ||

          color.toLowerCase() ===
            "#fff" ||

          color.toLowerCase() ===
            "white"
        ) {

          return `stroke="white"`;
        }

        return `stroke="black"`;
      }
    );

    return updated;
  };

  return (
    <>

      {/* ================= MOBILE ================= */}

      <div className="flex flex-col w-full min-h-screen bg-white md:hidden">

        {/* Header */}

        <div className="flex items-center justify-between px-4 py-3">

          <img
            src={ASSETS.lines}
            className="w-[24px] h-[24px] cursor-pointer"
            onClick={toggleMenu}
          />

          <div className="flex items-center gap-2">

            <img
              src={ASSETS.logo}
              className="w-[46px] h-[46px]"
            />

            <div>

              <h1 className="text-[24px] leading-tight font-pattaya">

                Ambit Tech

              </h1>

              <p className="text-[11px] leading-tight">

                Innovate. Integrate. Elevate.

              </p>

            </div>
          </div>

          <div className="w-10 h-10 mb-4 overflow-hidden rounded-md">

            <img
              src={profilePicURL}
              className="object-cover w-full h-full transform scale-125"
            />

          </div>
        </div>

        {/* Module Icons */}

        <div className="flex justify-center w-full mt-14">

          <div className="flex justify-center overflow-x-auto no-scrollbar">

            {moduleIcons.map(
              (item, index) => (

              <div
                key={`${item.name}-${index}`}
                className="w-[74px] h-[74px] flex items-center justify-center shrink-0 text-black [&>svg]:w-full [&>svg]:h-full"
                dangerouslySetInnerHTML={{
                  __html: fixSvg(
                    item.icon,
                    index
                  ),
                }}
              />

            ))}

          </div>
        </div>

        {/* Main Content */}

        <div className="flex-1 px-8 overflow-hidden">

          <div className="h-full pb-20 overflow-y-auto">

            <DashboardHome />

          </div>
        </div>

        {/* Floating Button */}

        <div className="fixed -translate-x-1/2 bottom-10 left-1/2">

          {Button ? (

            <Button
              token={authToken}
              onClick={handleCreateOrg}
              className="flex items-center gap-2 bg-[#CF0018] text-white px-4 py-2 rounded-xl whitespace-nowrap"
            >

              <img
                src={ASSETS.plus}
                className="w-[14px] h-[14px]"
              />

              Create Organization

            </Button>

          ) : (

            <div>Loading...</div>

          )}
        </div>
      </div>

      {/* ================= DESKTOP ================= */}

      <div className="hidden w-full min-h-screen bg-white md:flex">

        {/* Left Sidebar */}

        <div className="w-[4rem] flex flex-col justify-between items-center py-4">

          <div className="flex flex-col items-center">

            <div className="w-10 h-10 mb-4 overflow-hidden rounded-md">

              <img
                src={profilePicURL}
                className="object-cover w-full h-full transform scale-125"
              />

            </div>

            <div className="flex flex-col items-center gap-3">

              {moduleIcons.map(
                (item, index) => (

                <div
                  key={`${item.name}-${index}`}
                  className="w-7 h-7 text-black [&>svg]:w-full [&>svg]:h-full flex items-center justify-center"
                  dangerouslySetInnerHTML={{
                    __html: fixSvg(
                      item.icon,
                      index
                    ),
                  }}
                />

              ))}

            </div>
          </div>

          {/* Bottom Icons */}

          <div className="flex flex-col gap-4">

            <div className="w-10 h-10 bg-[#EBECEA] flex items-center justify-center rounded-md">

              <img
                src={ASSETS.icon5}
                className="w-5 h-5"
              />

            </div>

            <div className="w-8 h-8 bg-[#EBECEA] flex items-center justify-center rounded-md">

              <img
                src={ASSETS.icon6}
                className="w-5 h-5"
              />

            </div>

            <div className="w-8 h-8 bg-[#EBECEA] flex items-center justify-center rounded-md">

              <img
                src={ASSETS.icon7}
                className="w-5 h-5"
              />

            </div>
          </div>
        </div>

        {/* Middle Sidebar */}

        <div className="w-[250px] bg-[#F1F1F1] p-5">

          <h1 className="text-[20px] font-medium">

            Nova

          </h1>

          <div className="flex items-center gap-4 mt-8">

            <img
              src={ASSETS.icon8}
              className="w-5 h-5"
            />

            <span className="text-[#CF0018] font-bold">

              My accounts

            </span>
          </div>
        </div>

        {/* Main Dashboard */}

        <div className="flex-1 p-6">

          <DashboardHome />

        </div>
      </div>
    </>
  );
}